<template>
    <TableFilter :filter-refs="$refs"
                 @apply-filter="applyFilter"
    >
		<!-- Option -->
		<div>
			<div class="filter_head">{{$t("common.revolvingPutOption")}}</div>
			<div class="flex">
				<div class="filter_item">
					<TextFilter :label-text="$t('common.debtor')"
								column-name="debtorName"
								ref="filter_debtorName"
					></TextFilter>
					<TextFilter :label-text="$t('common.supplier')"
								column-name="sellerName"
								ref="filter_sellerName"
					></TextFilter>
					<TextFilter :label-text="$t('common.contractNumber')"
								column-name="referenceNumber"
								ref="filter_referenceNumber"
					></TextFilter>
					<DateFilter :label-text="$t('revolvingPutOption.optionStart')"
								column-name="startDate"
								ref="filter_startDate"
					></DateFilter>
					<DateFilter :label-text="$t('revolvingPutOption.optionEnd')"
								column-name="endDate"
								ref="filter_endDate"
					></DateFilter>
				</div>
				<div class="filter_item filter_item_xl">
					<FromToFilter :label-text="$t('revolvingPutOption.revolvingLine')"
								  column-name="saleLimit"
								  ref="filter_saleLimit"
					></FromToFilter>
					<FromToFilter :label-text="$t('revolvingPutOption.estimatedSalesVolume')"
								  column-name="estimatedSalesVolume"
								  ref="filter_estimatedSalesVolume"
					></FromToFilter>
					<FromToFilter :label-text="$t('revolvingPutOption.premium.withPercent')"
								  column-name="premium"
								  ref="filter_premium"
					></FromToFilter>
				</div>
			</div>
		</div>
		<!-- Payments -->
		<div class="filter_item filter_item_xl">
			<div class="filter_head">{{$t("revolvingPutOption.premiumPayment")}}</div>
			<DateFilter :label-text="$t('revolvingPutOption.premiumPayment.nextDueOn')"
						column-name="nextPremiumPaymentDueDate"
						ref="filter_nextPremiumPaymentDueDate"
			></DateFilter>
			<FromToFilter :label-text="$t('common.amount')"
						  column-name="totalPremiumAmount"
						  ref="filter_totalPremiumAmount"
			></FromToFilter>
			<FromToFilter :label-text="$t('common.outstanding.amount')"
						  column-name="outstandingPremiumAmount"
						  ref="filter_outstandingPremiumAmount"
			></FromToFilter>
			<FromToFilter :label-text="$t('common.outstanding.percent')"
						  column-name="outstandingPremiumPercent"
						  ref="filter_outstandingPremiumPercent"
			></FromToFilter>
		</div>
    </TableFilter>
</template>

<script>
import DateFilter from "@/components/newFilter/DateFilter";
import TextFilter from "@/components/newFilter/TextFilter";
import FromToFilter from "@/components/newFilter/FromToFilter";
import EnumFilter from "@/components/newFilter/EnumFilter";
import {enumDef} from "@/common/enumDefs";
import TableFilter from "@/components/newFilter/TableFilter";

export default {
    components: {
        TableFilter,
        EnumFilter,
        FromToFilter,
        DateFilter,
        TextFilter
    },
    data() {
        return {
            enumDef: enumDef
        };
    },
    methods: {
        applyFilter(filters) {
            this.$emit("apply-filter", filters);
        }
    },
};
</script>
